<template>
  <div class="lemontree_layer" @click.self="onClickClose(isDimmedClose)">
    <div
      :class="['inner_comm_layer',{ inner_comm_noborder : !isBorder, inner_comm_mo_layer : isLayer }]" :style="{'maxWidth' : maxWidth+'px', 'maxHeight' : maxHeight+'px'}">
      <div class="layer_head">
        <div class="area_left">
          <strong class="tit_layer">{{ title }}</strong>
          <div v-if="subTitle" class="txt_subtit">{{ subTitle }}</div>
        </div>
        <div v-if="hasHeadRight" class="area_right">
          <slot name="headRight"/>
        </div>
      </div>
      <div class="layer_body" :style="{ height : isHeightFit ? 'inherit' : '' }" ref="layerBody">
        <slot />
      </div>
      <div class="layer_foot">
        <div :class="['group_btn', `group_btn_type${footBtnCount}` ]">
          <Button
            v-if="closeBtnText"
            btnSize="small"
            btnStyle="secondary_border"
            :text="closeBtnText"
            @onClickBtn="onClickClose(true)" />
          <slot name="footBtn"/>
          <Button
            v-if="compeleteBtnText"
            btnSize="small"
            btnStyle="primary"
            :text="compeleteBtnText"
            :disabled="isDisabeldCompeleteBtn"
            @onClickBtn="onClickComplete" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@lemontree-ai/lemontree-admin-common-front/components/common/button/Button';
import { getDocumentElementPositon } from '@lemontree-ai/lemontree-admin-common-front/utils/elementUtils';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Popup',
  components:{
    Button
  },
  props:{
    mode: undefined,
    isBorder:{
      type:Boolean,
      default: true
    },
    isHeightFit:{
      type:Boolean,
      default: false
    },
    isLayer:{
      type:Boolean,
      default: false
    },
    maxWidth:{
      type: Number,
      default: 654
    },
    maxHeight: Number,
    title: String,
    subTitle: String,
    closeBtnText: String,
    compeleteBtnText: String,
    isDisabeldCompeleteBtn:{
      type:Boolean,
      default: false
    },
    isDimmedClose:{
      type:Boolean,
      default: true
    }
  },
  mounted(){
    document.body.style.overflow = "hidden";
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.onScroll();
    this.$refs.layerBody.addEventListener('scroll', this.onScroll);
  },
  unmounted(){
    document.body.style.overflow = "";
  },
  beforeUnmount(){
    window.removeEventListener('resize', this.onResize);
  },
  watch:{
    mode(newVal, oldVal){
      if(newVal != oldVal){
        this.$refs.layerBody.scrollTop = 0;
      }
    }
  },
  computed:{
    ...mapGetters('commonViewport', [ 'getWindowWidth', 'getWindowHeight', 'getScrollTop', 'getLayerHeight', 'getLayerScrollTop', 'getLayerPosition' ]),
    hasHeadRight(){
      return this.$slots['headRight']
    },
    addFootBtn(){
      if(!this.$slots['footBtn']) return [];
      return this.$slots['footBtn'].filter(item => item.tag);
    },
    hasFootBtn(){
      return this.addFootBtn.length > 0;
    },
    footBtnCount(){
      let result = 0;
      if(this.closeBtnText){
        result += 1;
      }
      if(this.compeleteBtnText){
        result += 1;
      }
      if(this.hasFootBtn){
        result += this.addFootBtn.length;
      }
      return result
    }
  },
  methods:{
    ...mapActions('commonViewport', [ 'fetchLayerInnerViewPort', 'fetchLayerBodyViewPort', 'fetchLayerBodyScroll' ]),
    onClickClose(isClose){
      if(!isClose) return;
      document.body.style.overflow = "";
      this.$emit('onClickClose');
    },
    onClickComplete(){
      document.body.style.overflow = "";
      this.$emit('onClickComplete');
    },
    onResize(){
      this.$nextTick(() => {
        const layerInner = this.$refs.innerLayer;
        if(layerInner){
          const innerPosition = getDocumentElementPositon(layerInner);
          innerPosition.bottom = innerPosition.top + layerInner.offsetHeight + this.getScrollTop;
          innerPosition.top += this.getScrollTop;
          this.fetchLayerInnerViewPort({ width: layerInner.offsetWidth, height: layerInner.offsetHeight, position:innerPosition });
        }

        const layerBody = this.$refs.layerBody;
        if(layerBody){
          const position = getDocumentElementPositon(layerBody);
          position.bottom = position.top + layerBody.offsetHeight + this.getScrollTop;
          position.top += this.getScrollTop;
          this.fetchLayerBodyViewPort({ width: layerBody.offsetWidth, height: layerBody.offsetHeight, position:position });
        }
      });
    },
    onScroll() {
      this.fetchLayerBodyScroll(this.$refs.layerBody.scrollTop);
    },
  }
}
</script>

<style lang="scss" scoped>
/* -- 레이어 팝업 -- */
.lemontree_layer{position:fixed;top:0;bottom:0;left:0;right:0;z-index:210;min-width:280px;padding:50px 0;font-size:0;background-color:rgba(34,34,34,.6);backdrop-filter:blur(1px);text-align:center;white-space:nowrap}
.lemontree_layer:after{display:inline-block;height:100%;vertical-align:middle;content:''}

.inner_comm_layer{overflow:hidden;display:inline-block;position:relative;width:90%;max-width:654px;border-radius:$CONTENT_RADIUS;background-color:#fff;white-space:normal;vertical-align:middle;box-sizing:border-box}


.layer_head{margin:0 24px;padding:20px 0 8px;text-align:left;background-color:#fff}
.layer_head:after{display:block;visibility:hidden;height:0;font-size:0;clear:both;content:''}
.layer_head .tit_layer{display:inline-block;font-weight:700;font-size:22px;line-height:38px;vertical-align:top}
.txt_subtit:before{display:inline-block;width:1px;height:16px;margin:4px 10px 0;background-color:#ccc;vertical-align:top;content:''}
.txt_subtit{display:inline-block;font-weight:600;font-size:16px;line-height:24px;color:#888;vertical-align:top}
.tit_layer + .txt_subtit{margin-top:8px}

.layer_body{overflow:hidden;overflow-y:auto;max-height:calc(100vh - 237px);padding:0 24px 40px;font-size:14px;line-height:16px;text-align:left;box-sizing:border-box}
// .layer_body > .info_docs:first-child,
// .layer_body > .group_content:first-child{margin-top:-20px}
.layer_body ::v-deep .tbl_view:first-child .tbl_top{margin-top:-10px}
.layer_body ::v-deep .tbl_view:first-child.non_margin_top .tbl_top{margin:0}
/* .layer_body ::v-deep .tbl_top{padding-bottom:10px} */
.layer_body ::v-deep .tbl_top .tit_tbl{font-weight:600;font-size:18px}
.layer_body ::v-deep .tbl_top .desc_tbl{font-size:14px;color:#888}
.layer_body ::v-deep .tbl_view + .tbl_view{margin-top:26px}

.layer_foot{background-color:rgba(255,255,255,.7);backdrop-filter:blur(3px);box-shadow:0 -2px 8px 0 rgba(34, 34, 34, 0.1);text-align:center}

.inner_comm_noborder .layer_head{border:0 none}
.inner_comm_noborder .layer_body{padding:0 0 20px;border:0 none}

// @media all and (max-width:600px){
//   .lemontree_layer{padding:0}
//   .inner_comm_layer{overflow:hidden;overflow-y:auto;width:100%;height: 100% !important;max-width:inherit !important;
//   max-height:inherit;padding:75px 0 30px;padding-bottom:calc(constant(safe-area-inset-bottom) + 112px);padding-bottom:calc(env(safe-area-inset-bottom) + 112px);box-sizing:border-box}
//   .layer_head{position:fixed;top:0;left:0;right:0;z-index:10;margin:0;padding:20px 20px 8px;}
//   .layer_body{max-height:inherit;padding:0 20px;box-sizing:border-box}
//   .layer_body ::v-deep .group_table_view{margin-top:-10px}
//   .layer_body > .info_docs:first-child,
//   .layer_body > .group_content:first-child{margin-top:10px}
//   .layer_body ::v-deep .tbl_view:first-child{padding-top:10px}
//   .layer_foot{position:fixed;bottom:0;left:0;right:0;z-index:10;padding:16px 20px;padding-bottom:calc(constant(safe-area-inset-bottom) + 16px);padding-bottom:calc(env(safe-area-inset-bottom) + 16px);}
//   .layer_foot .group_btn{padding:0}

//   .inner_comm_mo_layer{position:absolute;bottom:0;left:0;height:inherit !important;padding-top:85px;border-radius:16px 16px 0 0}
//   .inner_comm_mo_layer .layer_head{position:absolute}
// }
@media (prefers-color-scheme: dark) {
  .lemontree_layer{background-color:rgba(0,0,0,.7)}
  .inner_comm_layer{border:1px solid #333;background-color:#181818}
  .layer_head{border-bottom-color:#555;background-color:#181818}
  .layer_foot{border-top:1px solid #333;background:none}
}
</style>